import {printDepartureSheet} from "../network/PrintDepartureSheetAPI";

export const PrintDepartureSheetReducer = (state, action) => {
    switch (action.type) {
        case "PRINT_DEPARTURE_SHEET":
            const  {driversList, dispatcher} = action.data;
            printDepartureSheet(driversList, dispatcher);
            return {...state, isOnGoing: true, isSuccess: true};
        case "PRINT_DEPARTURE_SHEET_RESPONSE":
            return {...state, isOnGoing: false, isSuccess: true};
        default:
            return state
    }
};


// WEBPACK FOOTER //
// ./src/components/departureSheet/reducers/PrintDepartureSheetReducer.js